import { render, staticRenderFns } from "./Recepcionist.vue?vue&type=template&id=2118e370&scoped=true"
import script from "./Recepcionist.vue?vue&type=script&lang=js"
export * from "./Recepcionist.vue?vue&type=script&lang=js"
import style0 from "./Recepcionist.vue?vue&type=style&index=0&id=2118e370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2118e370",
  null
  
)

export default component.exports